import { render, staticRenderFns } from "./order.vue?vue&type=template&id=2205fbbd&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2205fbbd')) {
      api.createRecord('2205fbbd', component.options)
    } else {
      api.reload('2205fbbd', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=2205fbbd&", function () {
      api.rerender('2205fbbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotScore/order.vue"
export default component.exports